import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMATemplateOrientacao'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const GetQMATemplateListaOrientacao = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetQMATemplateListaOrientacao/${id}`, data, config)
const GetItensOrientacao = (id, fluxo, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetItensOrientacao/${id}/${fluxo}`, data, config)
const PostNovoItemOrientacao = (descricao, fluxo, empresa, data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/PostNovoItemOrientacao/${descricao}/${fluxo}/${empresa}`, data, config)
const DownloadOrientacaoTemplate = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/DownloadOrientacaoTemplate`, data, config)

const qmaTemplateSignature = {
  GetQMATemplateListaOrientacao,
  GetItensOrientacao,
  PostNovoItemOrientacao,
  DownloadOrientacaoTemplate
}

export default qmaTemplateSignature



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaTemplateGuidance.js